import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import moment from "moment";
import { BToast } from "bootstrap-vue";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    user: null,
    focusesPosition: [],
    profile: {},
    focuses: [],
    tags: [],
    lists: [],
    listEngine: [],
    names: [],
    tools: [],
    listConnectedUsersTools: [],
    listConnectedUsersNames: [],
    journeys: [],
    events: [],
    notifications: [],
    roles: [],
    namesNumbersPlaces: {},
    status: null,
    findAUser: null,
    joins: [],
    toDone: [],
    schedules: [],
    userDevice: [],
    notificationPermission: false,
    scheduleEvents: [],
    error: null,
    sessions: [],
    guideSessions: [],
    joinTools: {}
  },
  getters: {
    user(state) {
      return state.user;
    },
    profile(state) {
      return state.profile;
    },
    focuses(state) {
      return state.focuses;
    },
    tags(state) {
      return state.tags;
    },
    lists(state) {
      return state.lists;
    },
    listEngine(state) {
      return state.listEngine;
    },
    listNames(state) {
      return state.names;
    },
    listTools(state) {
      return state.tools;
    },
    listJourneys(state) {
      return state.journeys;
    },
    listEvents(state) {
      return state.events;
    },
    listNotifications(state) {
      return state.notifications;
    },
    listNamesNumbersPlaces(state) {
      return state.lists;
    },
    listRoles(state) {
      return state.roles;
    },
    status(state) {
      return state.status;
    },
    findAUser(state) {
      return state.findAUser;
    },
    joins(state) {
      return state.joins;
    },
    listConnectedUsersTools(state) {
      return state.listConnectedUsersTools;
    },
    listConnectedUsersNames(state) {
      return state.listConnectedUsersNames;
    },
    toDone(state) {
      return state.toDone;
    },
    schedules(state) {
      return state.schedules;
    },
    scheduleEvents(state) {
      return state.scheduleEvents;
    },
    joinTools(state) {
      return state.joinTools;
    },
    sessions(state) {
      return state.sessions;
    },
    guideSessions(state) {
      return state.guideSessions;
    },
    error(state) {
      return state.error;
    }
  },
  actions: {
    //asynchronous or synchronus
    sendEmail({ commit }, payload) {
      const { emailDetails } = payload;
      let send = firebase.functions().httpsCallable("sendInviteEmail");
      send({ emailDetails }).then(res => {
        console.log("successfully sent emails", res);
      });
    },
    sendNotification({ commit, state }, payload) {
      let notifFunc = firebase.functions().httpsCallable("notificationHandler");
      notifFunc({
        ...payload,
        userFrom: {
          uid: state.user.uid,
          name: state.user.displayName
            ? state.user.displayName
            : `${state.profile.firstname} ${
                state.profile.lastname ? state.profile.lastname : ""
              }`
        }
      })
        .then(res => {
          console.log("successfully send notification", res);
        })
        .catch(err => {
          console.log("error in send notification: ", err);
        });
    },
    signUpAction({ commit, state }, payload) {
      return new Promise((res, rej) => {
        commit("SET_STATUS", "loading");
        firebase
          .auth()
          .createUserWithEmailAndPassword(payload.email, payload.password)
          .then(response => {
            commit("UPDATE_USER", response.user);
            commit("SET_STATUS", "success");
            res(true);
          })
          .catch(error => {
            rej(error);
            commit("SET_STATUS", "failure");
            commit("SET_ERROR", error.message);
          });
      });
    },
    setUserName({ commit, state }, { fullName }) {
      const db = firebase.firestore();
      let profileRef = db.collection("users").doc(state.user.uid);
      console.log(state.user.uid);
      profileRef.get().then(doc => {
        profileRef
          .set({
            ...doc.data(),
            firstname: fullName.split(" ")[0],
            lastname: fullName
              .split(" ")
              .slice(1)
              .join(" ")
          })
          .then(function() {
            console.log("Document successfully updated!");
          })
          .catch(function(error) {
            console.error("Error updating document: ", error);
          });
      });
    },
    signInWithGoogleAction({ commit }) {
      commit("SET_STATUS", "loading");
      return new Promise((res, rej) => {
        const provider = new firebase.auth.GoogleAuthProvider();
        firebase
          .auth()
          .signInWithPopup(provider)
          .then(response => {
            setLocalStorageUserData(response);
            commit("UPDATE_USER", response.user);
            commit("SET_STATUS", "success");
            // commit("SET_ERROR", null);
            res(response.user);
          })
          .catch(error => {
            commit("SET_STATUS", "failure");
            commit("SET_ERROR", error.message);
            rej(error);
          });
      });
    },
    signInWithFacebookAction({ commit }) {
      commit("SET_STATUS", "loading");
      return new Promise((res, rej) => {
        const provider = new firebase.auth.FacebookAuthProvider();
        firebase
          .auth()
          .signInWithPopup(provider)
          .then(response => {
            setLocalStorageUserData(response);

            commit("UPDATE_USER", response.user);
            commit("SET_STATUS", "success");
            // commit("SET_ERROR", null);
            res(response.user);
          })
          .catch(error => {
            commit("SET_STATUS", "failure");
            commit("SET_ERROR", error.message);
            rej(error);
          });
      });
    },
    signInWithEmailAction({ commit }, payload) {
      commit("SET_STATUS", "loading");
      return new Promise((res, rej) => {
        firebase
          .auth()
          .signInWithEmailAndPassword(payload.email, payload.password)
          .then(response => {
            commit("UPDATE_USER", response.user);
            commit("SET_STATUS", "success");
            // commit("SET_ERROR", null);
            res(response.user);
          })
          .catch(error => {
            commit("SET_STATUS", "failure");
            commit("SET_ERROR", error.message);
            rej(error);
          });
      });
    },
    signOutAction({ commit }) {
      firebase
        .auth()
        .signOut()
        .then(response => {
          commit("UPDATE_USER", null);
          commit("SET_PROFILE", null);
          commit("SET_STATUS", "success");
          commit("SET_ERROR", null);
        })
        .catch(error => {
          commit("SET_STATUS", "failure");
          commit("SET_ERROR", error.message);
        });
    },
    getProfile({ commit, state }, uid) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let docRef = db.collection("users").doc(uid ? uid : state.user.uid);

        docRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              if (!uid) {
                commit("SET_PROFILE", { ...doc.data(), userId: doc.id });
              }
              res({ ...doc.data(), userId: doc.id });
            } else {
              res({});
              //TODO: Store error for stats and Improvements
            }
          })
          .catch(function(error) {
            rej(error);
            //TODO: Store error for stats and Improvements
          });
      });
    },
    getListJoins({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let docRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__joins");

        docRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              console.log(doc.data(), "ininiininini");
              commit("SET_JOINS", doc.data().focuses);
              res(true);
            } else {
              commit("SET_JOINS", []);
              res(true);
            }
          })
          .catch(function(error) {
            rej(error);
          });
      });
    },
    updateProfile({ commit, state }, profile) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let profileRef = db.collection("users").doc(state.user.uid);

        // Set the "capital" field of the city 'DC'
        return profileRef
          .update({
            ...profile
          })
          .then(function() {
            console.log("Document successfully updated!");
            res(true);
          })
          .catch(function(error) {
            // The document probably doesn't exist.
            console.error("Error updating document: ", error);
            rej(error);
          });
      });
    },
    updateProfileDashboardGuide({ commit, state }, { guide }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guideRef = db.collection("users").doc(state.user.uid);

        return guideRef.get().then(doc => {
          let data = { ...doc.data() };
          if (data._dashboards && data._dashboards.guide) {
            data._dashboards.guide = {
              ...data._dashboards.guide,
              ...guide,
              _updated_at: new Date()
            };
          } else {
            data._dashboards = {
              guide: {},
              developer: {}
            };
            data._dashboards.guide = {
              _created_at: new Date(),
              ...guide
            };
          }
          return guideRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    publishedGuideInfo({ commit, state }, { ref }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guideRef = db.collection("users").doc(state.user.uid);

        return guideRef.get().then(doc => {
          let data = { ...doc.data() };
          if (data._dashboards && data._dashboards.guide) {
            data._dashboards.guide = {
              ...data._dashboards.guide,
              _published_at: new Date()
            };
          }
          return guideRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateProfileDashboardBlogger({ commit, state }, { blogger }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let bloggerRef = db.collection("users").doc(state.user.uid);

        return bloggerRef.get().then(doc => {
          let data = { ...doc.data() };
          if (data._dashboards && data._dashboards.blogger) {
            data._dashboards.blogger = {
              ...data._dashboards.blogger,
              ...blogger,
              _updated_at: new Date()
            };
          } else {
            data._dashboards = {
              blogger: {},
              guide: {},
              developer: {}
            };
            data._dashboards.blogger = {
              _created_at: new Date(),
              ...blogger
            };
          }
          return bloggerRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    publishedBloggerInfo({ commit, state }, { ref }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let blogRef = db.collection("users").doc(state.user.uid);

        return blogRef.get().then(doc => {
          let data = { ...doc.data() };
          if (data._dashboards && data._dashboards.blogger) {
            data._dashboards.blogger = {
              ...data._dashboards.blogger,
              _published_at: new Date()
            };
          }
          return blogRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    getFocus({ commit, state }, { ref }) {
      return new Promise((res, rej) => {
        ref
          .get()
          .then(doc => {
            res({ ...doc.data(), focusId: doc.id });
          })
          .catch(err => {
            console.log("error in get focus: ", err);
            rej(err);
          });
      });
    },
    getFocuses({ commit, state }) {
      const db = firebase.firestore(); //Move to single place
      let collectionRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("focuses");

      collectionRef
        .where("_deleted_at", "==", null)
        // .get()
        .onSnapshot(function(querySnapshot) {
          let focuses = [];
          querySnapshot.forEach(function(doc) {
            focuses.push({ ...doc.data(), focusId: doc.id });
          });

          commit("SET_FOCUSES", focuses);
        });
      // .then(function(querySnapshot) {
      //   let focuses = [];
      //   querySnapshot.forEach(function(doc) {
      //     focuses.push({ ...doc.data(), focusId: doc.id });
      //   });
      //   commit("SET_FOCUSES", focuses);
      // })
      // .catch(function(error) {
      //   //TODO: Store error for stats and Improvements
      // });
    },
    updateFocuses({ dispatch, commit, state }, payload) {
      const db = firebase.firestore(); //Move to single place
      let collectionRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("focuses")
        .doc(payload.focusId);

      delete payload.focusId;
      if (!payload.state) {
        collectionRef.update({ ...payload }).then(() => {
          dispatch("updateFocusPosition");
        });
      } else {
        collectionRef.get().then(doc => {
          const generateLog = () => {
            let log = { _created_at: new Date() };
            if (payload.sphere) {
              log.sphere = payload.sphere;
            } else {
              log.sphere = doc.data().sphere;
            }
            if (payload.state) {
              log.state = payload.state;
            } else {
              log.state = doc.data().state;
            }
            if (payload.reason_stationed)
              log.reason_stationed = payload.reason_stationed;

            return log;
          };

          collectionRef
            .update({
              state: payload.state,
              lastUpdate: new Date(),
              log: firebase.firestore.FieldValue.arrayUnion(generateLog())
            })
            .then(data => {
              console.log("successfully updated", data);
              dispatch("updateFocusPosition");
            })
            .catch(err => {
              console.log(err);
            });
        });
      }
    },
    async updateFocusPosition({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        const items = state.focusesPosition;
        const copy = state.focuses;

        if (items.length > 0) {
          items.forEach(item => {
            if (item.items.length > 0) {
              item.items.forEach((root, index) => {
                const getIndex = copy.findIndex(
                  val => val.focusId === root.focusId
                );

                if (getIndex !== -1) {
                  copy[getIndex].state = item.from;
                  if (copy[getIndex].position === undefined) {
                    copy[getIndex] = Object.assign(copy[getIndex], {
                      position: index
                    });
                  } else {
                    copy[getIndex].position = index;
                  }
                }
              });
            }
          });
        }

        dispatch("saveFocusPosition");

        state.focusesPosition = [];
        resolve();
      });
    },
    saveFocusPosition({ commit, state }) {
      const db = firebase.firestore();

      let collectionRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("focuses");

      console.log("save focus position", state.focuses);

      state.focuses.forEach((val, index) => {
        collectionRef
          .doc(val.focusId)
          .set(
            {
              state: val.state,
              position: val.position !== undefined ? val.position : index
            },
            { merge: true }
          )
          .then(() => {
            console.log("updated");
            // resolve();
          })
          .catch(err => console.log(err));
      });
    },
    activateFocus(
      { commit, state },
      { focusId, listEmail, crewDetails, virtualState }
    ) {
      const db = firebase.firestore(); //Move to single place
      let focusesRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("focuses")
        .doc(focusId);
      let namesNumbersPlacesRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("tags")
        .doc("_names_numbers_places");
      let toSaveInNamesNumbersPlaces = [];

      focusesRef
        .get()
        .then(doc => {
          let crews = [...doc.data().crew];
          let counterIndexUnconnected = 0;
          crews = crews.map(el => {
            if (!el._connected_at) {
              let output = {
                ...el,
                _connected_at: new Date(),
                email: listEmail[counterIndexUnconnected],
                join_status: "notified",
                _type: virtualState[counterIndexUnconnected]
              };

              if (crewDetails[counterIndexUnconnected]) {
                let outputToSend = {
                  ...output
                };
                let connection = {
                  ...crewDetails[counterIndexUnconnected],
                  _names_numbers_places_id: el._names_numbers_places_id,
                  // uid: undefined,
                  // joins: undefined,
                  // _boarded_at: undefined,
                  user: db.doc(
                    "users/" + crewDetails[counterIndexUnconnected].uid
                  )
                };
                delete outputToSend.uid;
                delete connection.uid;
                delete connection.joins;
                delete connection._boarded_at;
                delete connection.shef;
                toSaveInNamesNumbersPlaces.push(connection);
                counterIndexUnconnected++;
                return outputToSend;
              } else {
                counterIndexUnconnected++;
                return output;
              }
            } else {
              return el;
            }
          });
          return focusesRef
            .update({
              _activated_at: new Date(),
              crew: crews
            })
            .then(() => {
              if (toSaveInNamesNumbersPlaces.length) {
                return namesNumbersPlacesRef.get().then(doc => {
                  let items = [...doc.data().items];
                  let listIdToUpdate = toSaveInNamesNumbersPlaces.map(
                    el => el._names_numbers_places_id
                  );
                  let newItems = items.map(el => {
                    if (listIdToUpdate.includes(el.uid)) {
                      return {
                        ...el,
                        connection: {
                          ...toSaveInNamesNumbersPlaces[
                            listIdToUpdate.indexOf(el.uid)
                          ]
                        }
                      };
                    } else {
                      return el;
                    }
                  });
                  return namesNumbersPlacesRef
                    .update({
                      items: newItems
                    })
                    .then(() => {
                      console.log(
                        "successfully saves connection in _names_numbers_places"
                      );
                    });
                });
              }
            });
        })
        .catch(err => {
          console.log("error on activation focus: ", err);
        });
    },
    getTags({ commit, state }, payload) {
      const db = firebase.firestore(); //Move to single place
      let collectionRef = db
        .collection("tags")
        .doc(state.user.uid)
        .collection("lists");

      collectionRef
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            commit("SET_TAGS", doc.data());
          });
        })
        .catch(function(error) {
          //TODO: Store error for stats and Improvements
        });
    },
    getLists({ commit, state }, payload) {
      const db = firebase.firestore(); //Move to single place
      let collectionRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("lists");
      collectionRef
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            commit("SET_LISTS", doc.data());
          });
        })
        .catch(function(error) {
          //TODO: Store error for stats and Improvements
        });
    },
    getListEngines({ commit, state }) {
      const db = firebase.firestore();
      let docEngine = db
        .collection("users")
        .doc(state.user.uid)
        .collection("lists")
        .doc("__engines");

      docEngine
        .get()
        .then(function(doc) {
          if (doc.exists) {
            commit("SET_LIST_ENGINE", doc.data().items);
          } else {
            //TODO: Store error for stats and Improvements
            commit("SET_LIST_ENGINE", []);
          }
        })
        .catch(function(error) {
          //TODO: Store error for stats and Improvements
        });
    },
    getListNamesNumbersPlaces({ commit, state }) {
      const db = firebase.firestore();
      let docNamesNumbersPlacesRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("tags")
        .doc("_names_numbers_places");

      docNamesNumbersPlacesRef
        .get()
        .then(function(doc) {
          if (doc.exists) {
            commit("SET_NAMES_NUMBERS_PLACES", doc.data());
          } else {
            //TODO: Store error for stats and Improvements
            commit("SET_NAMES_NUMBERS_PLACES", []);
          }
        })
        .catch(function(error) {
          //TODO: Store error for stats and Improvements
        });
    },
    getListNames({ commit, state }) {
      const db = firebase.firestore();
      let docNamesNumbersPlacesRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("tags")
        .doc("_names_numbers_places");

      docNamesNumbersPlacesRef
        .get()
        .then(function(doc) {
          if (doc.exists && doc.data().items && doc.data().items.length) {
            commit("SET_NAMES", doc.data().items);
          } else {
            commit("SET_NAMES", []);
          }
        })
        .catch(function(error) {
          //TODO: Store error for stats and Improvements
          console.error("Error get tools: ", error);
        });
    },
    getListTools({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let toolsRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_tools");

        toolsRef
          // .get()
          // .then
          .onSnapshot(function(doc) {
            if (doc.exists && doc.data().items && doc.data().items.length) {
              let items = doc.data().items;
              commit("SET_TOOLS", doc.data().items);
              res(doc.data().items);
            } else {
              commit("SET_TOOLS", []);
              res(true);
            }
          });
        // .catch(function(error) {
        //   console.error("Error get names: ", error);
        // });
      });
    },
    getJoinTools({ commit, state }, { uid }) {
      const db = firebase.firestore();
      let toolsRef = db
        .collection("users")
        .doc(uid)
        .collection("tags")
        .doc("_tools");

      toolsRef.onSnapshot(function(doc) {
        if (doc.exists && doc.data().items && doc.data().items.length) {
          commit("SET_JOIN_TOOLS", { uid, tools: doc.data().items });
        }
      });
    },
    getListToolsOtherUser({ commit, state }, { uid }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let toolsRef = db
          .collection("users")
          .doc(uid)
          .collection("tags")
          .doc("_tools");

        toolsRef.onSnapshot(function(doc) {
          if (doc.exists && doc.data().items && doc.data().items.length) {
            commit("SET_LIST_TOOLS_CONNECTED_USERS", {
              uid: uid,
              items: doc.data().items
            });
            res({ uid: uid, items: doc.data().items });
          }
        });
      });
    },
    getListNamesOtherUser({ commit, state }, { uid }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let namessRef = db
          .collection("users")
          .doc(uid)
          .collection("tags")
          .doc("_names_numbers_places");

        namessRef.onSnapshot(function(doc) {
          if (doc.exists && doc.data().items && doc.data().items.length) {
            commit("SET_LIST_NAMES_CONNECTED_USERS", {
              uid: uid,
              items: doc.data().items
            });
            res({ uid: uid, items: doc.data().items });
          }
        });
      });
    },
    getListJourneys({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let toolsRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        toolsRef
          .get()
          .then(function(doc) {
            if (doc.exists && doc.data().items && doc.data().items.length) {
              let items = doc.data().items;
              commit("SET_JOURNEYS", items);
              res(doc.data());
            } else {
              commit("SET_JOURNEYS", []);
              res(true);
            }
          })
          .catch(function(error) {
            console.error("Error get journeys: ", error);
          });
      });
    },
    getListSessions({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _userSessionsRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__sessions");

        _userSessionsRef
          .get()
          .then(function(doc) {
            // querySnapshot.forEach((doc) => {
            if (
              doc.exists &&
              doc.data().sessions &&
              doc.data().sessions.length
            ) {
              commit("SET_USER_SESSIONS", [...doc.data().sessions]);
              res(doc.data().sessions);
            } else {
              res(true);
            }
            // });
          })
          .catch(function(error) {
            console.error("Error get user sessions: ", error);
            rej(error);
          });
      });
    },
    getListGuideSessions({ commit, state }, id) {
      let uid = null;
      if (id) {
        uid = id;
      } else {
        uid = state.user.uid;
      }
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _guideSessionsRef = db
          .collection("users")
          .doc(uid)
          .collection("lists")
          .doc("__guide_sessions");

        _guideSessionsRef
          .get()
          .then(function(doc) {
            // querySnapshot.forEach((doc) => {
            if (
              doc.exists &&
              doc.data().sessions &&
              doc.data().sessions.length
            ) {
              commit("SET_GUIDE_SESSIONS", [...doc.data().sessions]);
              res(doc.data().sessions);
            } else {
              res(true);
            }
            // });
          })
          .catch(function(error) {
            console.error("Error get guide sessions: ", error);
            rej(error);
          });
      });
    },
    getListNotifications({ commit, state }) {
      const db = firebase.firestore();
      let __notificationsRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("lists")
        .doc("__notifications");

      __notificationsRef
        // .get()
        .onSnapshot(function(doc) {
          if (doc.exists && doc.data().items && doc.data().items.length) {
            // let items = doc.data().items;
            commit("SET_NOTIFICATIONS", doc.data().items);
          } else {
            commit("SET_NOTIFICATIONS", []);
          }
        });
      // .then(function(doc) {
      // debugger;
      // })
      // .catch(function(error) {
      // console.error("Error get notifications: ", error);
      // });
    },
    getListRoles({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let rolesRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_roles");

        rolesRef.get().then(doc => {
          if (doc.exists) {
            res(doc.data().items);
            commit("SET_ROLES", { roles: doc.data().items });
          } else {
            commit("SET_ROLES", { roles: [] });
          }
        });
      });
    },
    addSchedule({ commit, state }, { schedule }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        const schedulePath = `users/${state.user.uid}/lists/__schedule`;
        const scheduleRef = db.doc(schedulePath);
        return scheduleRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let schedule_name = Date.now();
              scheduleRef.update({
                _schedules: firebase.firestore.FieldValue.arrayUnion({
                  schedule_name: schedule_name,
                  _created_at: new Date()
                })
              });
            } else {
              return scheduleRef
                .set({
                  _schedules: {
                    schedule_name: Date.now(),
                    _created_at: new Date()
                  }
                })
                .then(() => {
                  console.log("successfully saved a schedule event");
                  res(true);
                });
            }
          })
          .catch(err => {
            console.log("error in save schedule event: ", err);
            rej(err);
          });
      });
    },
    getSchedules({ commit, state }) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        let scheduleRef = db.doc(`users/${state.user.uid}/lists/__schedules`);
        scheduleRef.onSnapshot(snapshot => {
          if (snapshot.exists) {
            commit("SET_SCHEDULES", { schedules: snapshot.data()._schedules });
            res(snapshot.data().items);
          } else {
            res([]);
          }
        });
      });
    },
    addScheduleEvent({ commit, state }, { scheduleEvent }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        const scheduleRef = db.doc(`users/${state.user.uid}/lists/__schedule`);
        return scheduleRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let scheduleEvents = [...doc.data().items];
              return scheduleRef
                .update({
                  items: [...scheduleEvents, { ...scheduleEvent }]
                })
                .then(() => {
                  console.log("successfully a schedule event");
                  res(true);
                });
            } else {
              return scheduleRef
                .set({
                  _created_at: new Date(),
                  items: [{ ...scheduleEvent }]
                })
                .then(() => {
                  console.log("successfully saved a schedule event");
                  res(true);
                });
            }
          })
          .catch(err => {
            console.log("error in save schedule event: ", err);
            rej(err);
          });
      });
    },
    getScheduleEvents({ commit, state }) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        let scheduleRef = db.doc(`users/${state.user.uid}/lists/__schedule`);
        scheduleRef.onSnapshot(snapshot => {
          if (snapshot.exists) {
            commit("SET_SCHEDULE_EVENTS", {
              scheduleEvents: snapshot.data().items
            });
            res(snapshot.data().items);
          } else {
            res([]);
          }
        });
      });
    },
    removeScheduleEvent({ commit, state }, { scheduleEvent }) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        let scheduleRef = db.doc(`users/${state.user.uid}/lists/__schedule`);
        return scheduleRef
          .get()
          .then(doc => {
            let scheduleEvents = [...doc.data().items];
            scheduleEvents = scheduleEvents.map(el => {
              if (el.text === scheduleEvent.text) {
                return {
                  ...el,
                  _deleted_at: new Date()
                };
              }
              return el;
            });
            return scheduleRef
              .update({
                items: scheduleRef
              })
              .then(() => {
                console.log("successfully removed Schedule Event");
                res(true);
              });
          })
          .catch(err => {
            console.log("error in removing Schedule Event: ", err);
            rej(err);
          });
      });
    },
    addFocusedJourney(
      { commit, state },
      { destination, engines, crew, tools, sphere, focusType, journey }
    ) {
      return new Promise((res, rej) => {
        destination = destination ? destination : {};
        crew = crew ? crew : [];
        tools = tools ? tools : [];
        sphere = sphere ? sphere : "";
        journey = journey ? journey : {};

        const db = firebase.firestore(); //Move to single place
        let collectionRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("focuses");

        // updating all positions for focuses ---
        collectionRef.get().then(querySnapshot => {
          querySnapshot.forEach(element => {
            const items = element.data();
            if (items.state === "ondeck") {
              collectionRef
                .doc(element.id)
                .set(
                  {
                    position: +items.position + 1
                  },
                  { merge: true }
                )
                .then(() => {
                  console.log("positions focus updated!");
                });
            }
          });
          collectionRef
            .add({
              destination,
              engines,
              crew,
              tools,
              sphere,
              _deleted_at: null,
              position: 0,
              state: "ondeck",
              journey,
              log: [{ sphere, state: "ondeck", _created_at: new Date() }]
            })
            .then(function(docRef) {
              console.log(docRef);
              console.log("Document written with ID: ", docRef.id);
              res(docRef.path);
              localStorage.removeItem(focusType);
            })
            .catch(function(error) {
              rej(error);
              console.error("Error adding document: ", error);
            });
        });
      });
    },
    addNameNumberPlace({ commit, state }, { nameNumberPlace }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let nameNumberPlaceRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_names_numbers_places");

        nameNumberPlaceRef
          .get()
          .then(function(doc) {
            if (doc.exists) {
              let updated = doc.data().updated;
              ++updated;
              let toSave = {
                items: [
                  ...doc.data().items,
                  {
                    ...nameNumberPlace,
                    uid: updated
                  }
                ],
                updated
              };
              return nameNumberPlaceRef.update(toSave).then(() => {
                console.log("Save new name success");
                res({ ...nameNumberPlace, uid: updated });
              });
            } else {
              let toSave = {
                items: [{ ...nameNumberPlace, uid: 0 }],
                updated: 0,
                _created_at: new Date(),
                _deleted_at: null
              };
              return nameNumberPlaceRef.set(toSave).then(() => {
                console.log("Save new name success");
                res({ ...nameNumberPlace, uid: 0 });
              });
            }
          })
          .catch(err => {
            console.log("Error add new name: ", err);
          });
      });
    },
    updateNameNumberPlace({ commit, state }, { nameNumberPlace }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let nameNumberPlaceRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_names_numbers_places");

        nameNumberPlaceRef.get().then(function(doc) {
          let existing = doc.data().items;
          let toSave = existing.map(el => {
            if (el.uid === nameNumberPlace.uid) {
              el = {
                ...nameNumberPlace,
                updated_at: new Date()
              };
            }
            return el;
          });
          res(
            nameNumberPlaceRef
              .update({
                items: toSave
              })
              .then(() => {
                console.log("Update NameNumber Success");
              })
              .catch(err => {
                console.log("Error in update Name Number:", err);
              })
          );
        });
      });
    },
    updateTool({ commit, state }, { tool }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let toolRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_tools");

        toolRef.get().then(function(doc) {
          let existing = doc.data().items;
          let toSave = existing.map(el => {
            if (el.uid === tool.uid) {
              el = {
                ...tool,
                updated_at: new Date()
              };
            }
            return el;
          });
          res(
            toolRef
              .update({
                items: toSave
              })
              .then(() => {
                console.log("Update Tool Success");
              })
              .catch(err => {
                console.log("Error in update Tool:", err);
              })
          );
        });
      });
    },
    addAnEngines({ commit, state }, { engines }) {
      //Change to the ability of adding an array of commitments
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let engineRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__engines");

        let enginesToSave = engines.filter(el => !el.uid);

        if (!enginesToSave.length) {
          res(engines);
        } else {
          let toSave = {};
          res(
            engineRef
              .get()
              .then(function(doc) {
                if (doc.exists) {
                  let updated = doc.data().updated;
                  enginesToSave.map(el => (el.uid = ++updated));
                  toSave = {
                    items: [...doc.data().items, ...enginesToSave],
                    updated
                  };
                  return engineRef.update(toSave).then(function() {
                    console.log("Add List Engines Success ");
                    let toSaveElements = [...toSave.items];
                    engines.map(el => {
                      if (!el.uid) {
                        let newEl = toSaveElements[0];
                        toSaveElements.splice(1);
                        return newEl;
                      }
                    });
                    return engines;
                    // return toSave.items._elements;
                  });
                } else {
                  enginesToSave.map((el, index) => (el.uid = index));
                  toSave = {
                    items: [...enginesToSave],
                    _created_at: new Date(),
                    _deleted_at: null,
                    updated: engines.length - 1
                  };
                  return engineRef.set(toSave).then(function() {
                    console.log("Add List Engines Success ");
                    let toSaveElements = [...toSave.items];
                    engines.map(el => {
                      if (!el.uid) {
                        let newEl = toSaveElements[0];
                        toSaveElements.splice(1);
                        return newEl;
                      }
                    });
                    return engines;
                  });
                }
              })
              .catch(function(error) {
                console.error("Error adding document: ", error);
                return;
              })
          );
        }
      });
    },
    addEventInEngineInFocus({ commit, state }, { event, focusId, engine_id }) {
      return new Promise((res, rej) => {
        if (event && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("focuses")
            .doc(focusId);

          let eventStriped = { ...event };
          delete eventStriped.text;
          delete eventStriped.when;
          delete eventStriped.engine_id;
          delete eventStriped.daysEnabled;
          delete eventStriped.daysPattern;
          delete eventStriped.focus_tool_ids;
          delete eventStriped._created_at;

          res(
            focusRef
              .get()
              .then(doc => {
                let engineFromDatabase = doc.data().engines;
                let engineEdited = engineFromDatabase.map(el => {
                  if (el.engine_id === engine_id) {
                    return {
                      ...el,
                      _events: eventStriped
                    };
                  } else {
                    return el;
                  }
                });
                console.log(engineEdited, "ini yang mau di savee");
                return focusRef
                  .update({
                    engines: engineEdited
                  })
                  .then(() => {
                    console.log("successfully add event in engine in a focus");
                  });
              })
              .catch(err => {
                console.log("error in add event in engine in focus:", err);
              })
          );
        }
      });
    },
    saveEventInLists({ commit, state }, { focus, focusId }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let { _duration } = focus;
        let _events = [];
        let dayList = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
        let today = dayList[new Date().getDay()];

        let eventsActiveRef = db.doc(
          `users/${state.user.uid}/lists/_events/active/${focusId}`
        );
        let eventsLogRef = db.doc(
          `users/${state.user.uid}/lists/_events/log/${focusId}`
        );

        focus.engines.forEach((el, index) => {
          if (el._events && el._events.days) {
            el._events.days.forEach((elWeek, indexWeek) => {
              let days = { ...elWeek };
              for (let day in days) {
                // let to =
                //   _duration === "6 Weeks" ? 6 : _duration === "1 Week" && 1;
                // if (to) {
                // for (let i = 0; i < to + 1; i++) {
                //   if (
                //     (i === 0 &&
                //       dayList.indexOf(day) >= dayList.indexOf(today)) ||
                //     i > 0
                //   ) {
                let date = moment().day(dayList.indexOf(day) + indexWeek * 7);
                let momentDate = moment(date._d).format("YYYY-MM-DD");
                if (days[day] && days[day].start && days[day].end) {
                  _events.push({
                    _start_at: new Date(
                      moment(momentDate + " " + days[day].start)
                    ),
                    _end_at: new Date(moment(momentDate + " " + days[day].end)),
                    place: days[day].place,
                    engine: el.text
                  });
                }
                //   }
                // }
                // console.log(_events, "ini events logoggoog");
                // } else {
                // console.log(_events, "ini events logoggoog2");
                // let momentDate = moment(new Date()).format("YYYY-MM-DD");

                // _events.push({
                //   _start_at: new Date(
                //     moment(momentDate + " " + days[day].start)
                //   ),
                //   _end_at: new Date(moment(momentDate + " " + days[day].end)),
                //   place: days[day].place,
                //   engine: el.text,
                // });
                // }
              }
            });
          }
        });
        return eventsActiveRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let eventsActive = [...doc.data().events];
              // console.log(
              //   moment(doc.data()._created_at.toDate()).format("DD-MM-YYYY"),
              //   "kokokokokokokokokokokmomookokomoko,mo",
              //   doc.data()._created_at
              // );
              let logs = {
                [moment(doc.data()._created_at.toDate()).unix()]:
                  // .format(
                  // "DD-MM-YYYY")
                  eventsActive
              };

              const updateActiveRef = () => {
                eventsActiveRef
                  .update({
                    _created_at: new Date(),
                    _updated_at: new Date(),
                    events: [..._events]
                  })
                  .then(() => {
                    // console.log("succesfully save in _list => _events");
                    res(true);
                  });
              };

              return eventsLogRef.get().then(doc => {
                if (doc.exists) {
                  eventsLogRef
                    .update({
                      _updated_at: new Date(),
                      logs: { ...doc.data().logs, ...logs }
                    })
                    .then(() => {
                      return updateActiveRef();
                    });
                } else {
                  eventsLogRef
                    .set({
                      _created_at: new Date(),
                      logs: { ...logs }
                    })
                    .then(() => {
                      return updateActiveRef();
                    });
                }
              });
            } else {
              return eventsActiveRef
                .set({
                  _created_at: new Date(),
                  events: [..._events]
                })
                .then(() => {
                  // console.log("succesfully save in _list => _events");
                  res(true);
                });
            }
          })
          .catch(err => {
            console.log("error in saving in list => _events: ", err);
          });
      });
    },
    addNames({ commit, state }, { names }) {
      //Change to the ability of adding an array of commitments
      console.log("name", names);
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let namesNumbersPlacesRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_names_numbers_places");

        let namesToSave = names.filter(el => !el.uid && el.uid !== 0);

        if (!namesToSave.length) {
          res(names);
        } else {
          let toSave = {};

          res(
            namesNumbersPlacesRef
              .get()
              .then(function(doc) {
                if (doc.exists) {
                  let updated = doc.data().updated;
                  namesToSave.map(el => (el.uid = ++updated));

                  toSave = {
                    items: firebase.firestore.FieldValue.arrayUnion(
                      ...namesToSave.map(el => ({
                        uid: el.uid,
                        info: {
                          firstname:
                            el.text.indexOf(" ") > 0
                              ? el.text.slice(0, el.text.indexOf(" "))
                              : el.text,
                          lastname:
                            el.text.indexOf(" ") > 0
                              ? el.text.slice(el.text.indexOf(" ") + 1)
                              : null,
                          email: el.email
                        }
                      }))
                    ),
                    updated
                  };
                  return namesNumbersPlacesRef.update(toSave).then(function() {
                    let toSaveElements = [
                      ...doc.data().items.map((el, index) => {
                        return {
                          ...el,
                          text: `${el.info.firstName +
                            (el.info.lastName ? " " + el.info.lastName : "")}`,
                          // subText: el.info.lastName,
                          subText: namesToSave[0].subText,
                          info: undefined
                        };
                      })
                    ];
                    names.map(el => {
                      if (!el.uid) {
                        let newEl = toSaveElements[0];
                        toSaveElements.splice(1);
                        return newEl;
                      }
                    });
                    return names;
                  });
                } else {
                  namesToSave.map((el, index) => (el.uid = index));
                  toSave = {
                    items: [
                      ...namesToSave.map(el => ({
                        uid: el.uid,
                        info: {
                          firstname:
                            el.text.indexOf(" ") > 0
                              ? el.text.slice(0, el.text.indexOf(" "))
                              : el.text,
                          lastname:
                            el.text.indexOf(" ") > 0
                              ? el.text.slice(el.text.indexOf(" "))
                              : null
                        }
                      }))
                    ],
                    _created_at: new Date(),
                    _deleted_at: null,
                    updated: names.length - 1
                  };
                  return namesNumbersPlacesRef.set(toSave).then(function() {
                    console.log("Add List Names Success ");
                    let toSaveElements = [
                      ...toSave.items.map(el => ({
                        ...el,
                        text: el.info.firstName,
                        subText: el.info.lastName,
                        info: undefined
                      }))
                    ];
                    names.map(el => {
                      if (!el.uid) {
                        let newEl = toSaveElements[0];
                        toSaveElements.splice(1);
                        return newEl;
                      }
                    });
                    return names;
                  });
                }
              })
              .catch(function(error) {
                console.error("Error adding document: ", error);
                return;
              })
          );
        }
      });
    },
    addTools({ commit, state }, { tools }) {
      //Change to the ability of adding an array of commitments
      return new Promise((res, rej) => {
        const listToolsToolId = state.tools.map(el => el.tooldetail.toolId);
        const db = firebase.firestore(); //Move to single place
        let toolsRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_tools");

        tools = tools.map(el => {
          if (!el.uid) {
            if (listToolsToolId.includes(el.tooldetail.toolId)) {
              el.uid =
                state.tools[listToolsToolId.indexOf(el.tooldetail.toolId)].uid;
            }
          }
          return el;
        });
        let toolsToSave = tools.filter(el => !el.uid);
        toolsToSave = toolsToSave.filter(
          el => !listToolsToolId.includes(el.tooldetail.toolId)
        );

        if (!toolsToSave.length) {
          res(tools);
        } else {
          let toSave = {};

          res(
            toolsRef
              .get()
              .then(function(doc) {
                if (doc.exists) {
                  let updated = doc.data().updated;
                  toolsToSave.map(el => (el.uid = ++updated));

                  toSave = {
                    items: [...doc.data().items, ...toolsToSave],
                    updated
                  };
                  return toolsRef.update(toSave).then(function() {
                    console.log("Add List Tools Success ");
                    let toSaveElements = [...toSave.items];

                    tools.map(el => {
                      if (!el.uid) {
                        let newEl = toSaveElements[0];
                        toSaveElements.splice(1);
                        return newEl;
                      }
                    });
                    return tools;
                  });
                } else {
                  toolsToSave.map((el, index) => (el.uid = index));
                  toSave = {
                    items: [...toolsToSave],
                    _created_at: new Date(),
                    _deleted_at: null,
                    updated: tools.length - 1
                  };

                  return toolsRef.set(toSave).then(function() {
                    console.log("Add List Tools Success ");

                    let toSaveElements = [...toSave.items];

                    tools.map(el => {
                      if (!el.uid) {
                        let newEl = toSaveElements[0];
                        toSaveElements.splice(1);
                        return newEl;
                      }
                    });
                    return tools;
                  });
                }
              })
              .catch(function(error) {
                console.error("Error adding document: ", error);
                return;
              })
          );
        }
      });
    },
    addRoles({ commit, state }, { roles }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let rolesRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("tags")
          .doc("_roles");
        res(
          rolesRef
            .get()
            .then(doc => {
              if (doc.exists) {
                let allRoles = doc.data().items.map(el => el.text);
                let filteredRoles = roles.filter(
                  el => !allRoles.includes(el.text)
                );
                let updated = doc.data().updated;
                let filteredRolesWuid = filteredRoles.map(el => ({
                  ...el,
                  uid: ++updated
                }));

                return rolesRef
                  .update({
                    items: firebase.firestore.FieldValue.arrayUnion(
                      ...filteredRolesWuid
                    ),
                    updated
                  })
                  .then(() => {
                    console.log("successfully save roles");
                  });
              } else {
                let rolesWuid = roles.map((el, index) => ({
                  ...el,
                  uid: index
                }));
                return rolesRef
                  .set({
                    _created_at: new Date(),
                    items: rolesWuid,
                    updated: roles.length - 1
                  })
                  .then(() => {
                    console.log("successfully save roles");
                  });
              }
            })
            .catch(err => {
              console.log("error in saving rolesP: ", err);
            })
        );
      });
    },
    addCrewIntoFocus({ commit, state }, { crew, focusId }) {
      return new Promise((res, rej) => {
        if (crew && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("focuses")
            .doc(focusId);

          focusRef
            .update({
              crew: firebase.firestore.FieldValue.arrayUnion(crew)
            })
            .then(() => {
              console.log("successfully added new crew into a focus");
              res(true);
            })
            .catch(err => {
              console.log("error in adding new crew into focus:", err);
              rej(err);
            });
        }
      });
    },
    addEngineIntoFocus({ commit, state }, { engine, focusId }) {
      return new Promise((res, rej) => {
        if (engine && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("focuses")
            .doc(focusId);

          focusRef
            .update({
              engines: firebase.firestore.FieldValue.arrayUnion(engine)
            })
            .then(() => {
              console.log("successfully added new engine into a focus");
              res(true);
            })
            .catch(err => {
              console.log("error in adding new engine into focus:", err);
              rej(err);
            });
        }
      });
    },
    editCrewInFocus({ commit, state }, { crew, focusId }) {
      return new Promise((res, rej) => {
        if (crew && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("focuses")
            .doc(focusId);

          res(
            focusRef
              .get()
              .then(doc => {
                let crewFromDatabase = doc.data().crew;
                let crewEdited = crewFromDatabase.map(el => {
                  if (
                    el._names_numbers_places_id ===
                    crew._names_numbers_places_id
                  ) {
                    return crew;
                  } else {
                    return el;
                  }
                });
                return focusRef
                  .update({
                    crew: crewEdited
                  })
                  .then(() => {
                    console.log("successfully edit crew in a focus");
                  });
              })
              .catch(err => {
                console.log("error in editing crew in focus:", err);
              })
          );
        }
      });
    },
    editEngineInFocus({ commit, state }, { engine, focusId }) {
      return new Promise((res, rej) => {
        if (engine && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("focuses")
            .doc(focusId);

          res(
            focusRef
              .get()
              .then(doc => {
                let engineFromDatabase = doc.data().engines;
                let engineEdited = engineFromDatabase.map(el => {
                  if (el.engine_id === engine.engine_id) {
                    return engine;
                  } else {
                    return el;
                  }
                });
                return focusRef
                  .update({
                    engines: engineEdited
                  })
                  .then(() => {
                    console.log("successfully edit engine in a focus");
                  });
              })
              .catch(err => {
                console.log("error in editing engine in focus:", err);
              })
          );
        }
      });
    },
    removeCrewInFocus(
      { commit, state },
      { _names_numbers_places_id, focusId }
    ) {
      return new Promise((res, rej) => {
        if (_names_numbers_places_id && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("focuses")
            .doc(focusId);

          focusRef
            .get()
            .then(doc => {
              let crews = doc.data().crew;
              let crewsToSave = crews.map(el => {
                if (el._names_numbers_places_id === _names_numbers_places_id) {
                  return {
                    ...el,
                    _deleted_at: new Date()
                  };
                } else {
                  return el;
                }
              });
              return focusRef
                .update({
                  crew: crewsToSave
                })
                .then(() => {
                  console.log("successfully remove crew from a focus");
                  res(true);
                });
            })
            .catch(err => {
              console.log("error in remove crew from focus:", err);
            });
        }
      });
    },
    removeEngineInFocus({ commit, state }, { engine_id, focusId }) {
      return new Promise((res, rej) => {
        if (typeof +engine_id == "number" && focusId) {
          const db = firebase.firestore();
          let focusRef = db
            .collection("users")
            .doc(state.user.uid)
            .collection("focuses")
            .doc(focusId);

          focusRef
            .get()
            .then(doc => {
              let engines = doc.data().engines;
              let enginesToSave = engines.map(el => {
                if (el.engine_id === engine_id) {
                  return {
                    ...el,
                    _deleted_at: new Date()
                  };
                } else {
                  return el;
                }
              });
              return focusRef
                .update({
                  engines: enginesToSave
                })
                .then(() => {
                  console.log("successfully remove crew from a focus");
                  res(true);
                });
            })
            .catch(err => {
              console.log("error in remove crew from focus:", err);
            });
        }
      });
    },
    addStationReason({ commit, state }, { reason }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let stationRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__station_reasons");

        let reasonToSave =
          reason.uid !== null && reason.uid > -1 ? null : reason;
        if (
          !reasonToSave &&
          (reason.uid === 0 || reason.uid === 1 || reason.uid === 2)
        ) {
          res(reason);
        } else {
          let toSave = {};
          res(
            stationRef
              .get()
              .then(function(doc) {
                if (doc.exists) {
                  let updated = doc.data().updated;
                  reasonToSave = { ...reasonToSave, uid: ++updated };
                  toSave = {
                    items: firebase.firestore.FieldValue.arrayUnion(
                      reasonToSave
                    ),
                    updated
                  };
                  return stationRef.update(toSave).then(function() {
                    console.log("Add Reason Stationed Success ");

                    return toSave.items._elements
                      ? toSave.items._elements[
                          toSave.items._elements.length - 1
                        ]
                      : null;
                  });
                } else {
                  toSave = {
                    items: [
                      {
                        uid: "a",
                        text: "I do not have enough mouney for this  journey"
                      },
                      { uid: "b", text: "I do not have time" },
                      { uid: "c", text: "I am not interested anymore" },
                      { ...reason, uid: 0 }
                    ],
                    _created_at: new Date(),
                    _deleted_at: null,
                    updated: 3
                  };
                  return stationRef.set(toSave).then(function() {
                    console.log("Add Reason Stationed Success ");
                    return toSave.items[0];
                  });
                }
              })
              .catch(function(error) {
                console.error("Error adding document: ", error);
                return;
              })
          );
        }
      });
    },
    addJourneys({ commit, state }, journeys) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        let updated = 0;
        journeys.map(el => (el._created_at = new Date()));
        journeysRef.get().then(doc => {
          if (doc.exists) {
            let existingJourneys = doc.data().items;
            updated = doc.data().updated;
            journeys.map((el, index) => (el.uid = updated + index));
            journeysRef
              .update({
                _updated_at: new Date(),
                updated: updated + 1,
                items: [...existingJourneys, ...journeys]
              })
              .then(() => {
                res(true);
              })
              .catch(err => {
                rej(err);
              });
          } else {
            journeys.map((el, index) => (el.uid = updated + index));
            journeysRef
              .set({
                _created_at: new Date(),
                _updated_at: new Date(),
                _deleted_at: null,
                updated: journeys.length + 1,
                items: [...journeys]
              })
              .then(() => {
                res(true);
              })
              .catch(err => {
                rej(err);
              });
          }
        });
      });
    },
    addJourney({ commit, state }, journey) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        journeysRef.get().then(doc => {
          if (doc.exists) {
            let updated = doc.data().updated;
            journeysRef
              .update({
                updated: updated + 1,
                _updated_at: new Date(),
                items: firebase.firestore.FieldValue.arrayUnion({
                  _created_at: new Date(),
                  uid: updated + 1,
                  ...journey
                })
              })
              .then(() => {
                res(true);
              })
              .catch(err => {
                rej(err);
              });
          } else {
            console.log("no hi");
            journeysRef
              .set({
                _created_at: new Date(),
                _updated_at: new Date(),
                _deleted_at: null,
                updated: 0,
                items: []
              })
              .then(() => {
                let updated = 0;
                journeysRef
                  .update({
                    updated: updated + 1,
                    items: firebase.firestore.FieldValue.arrayUnion({
                      _created_at: new Date(),
                      uid: updated + 1,
                      ...journey
                    })
                  })
                  .then(() => {
                    res(true);
                  })
                  .catch(err => {
                    rej(err);
                  });
              })
              .catch(err => {
                rej(err);
              });
          }
        });
      });
    },
    updateJourney({ commit, state }, journey) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        journeysRef.get().then(doc => {
          let items = doc.data().items;
          let newItems = items.map(el => {
            if (el.uid === journey.uid) {
              el = { ...el, ...journey, _updated_at: new Date() };
            }
            return el;
          });
          journeysRef
            .update({
              _updated_at: new Date(),
              items: newItems
            })
            .then(() => {
              res(true);
            })
            .catch(err => {
              rej(err);
            });
        });
      });
    },
    archiveJourney({ commit, state }, journey) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        let journeysRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("_journeys");

        journeysRef.get().then(doc => {
          let items = doc.data().items;
          let newItems = items.map(el => {
            if (el.uid === journey.uid) {
              el = { ...el, _archived_at: new Date() };
            }
            return el;
          });
          journeysRef
            .update({
              _updated_at: new Date(),
              items: newItems
            })
            .then(() => {
              res(true);
            })
            .catch(err => {
              rej(err);
            });
        });
      });
    },
    addStatesFocusesNotif(
      { commit, state },
      { crewDetails, listEmail, focusId }
    ) {
      const db = firebase.firestore();
      let statesFocusesRef = db.collection("states").doc("focuses");
      if (crewDetails.length) {
        let newStateFocusesList = crewDetails.map((el, index) => {
          let output = {
            _created_at: new Date(),
            state: "notified",
            focus: db.doc(`users/${state.user.uid}/focuses/${focusId}`),
            email: listEmail[index]
          };
          if (crewDetails[index]) {
            return {
              ...output,
              user: db.doc(`users/${crewDetails[index].uid}`)
            };
          } else {
            return output;
          }
        });
        statesFocusesRef
          .update({
            focuses: firebase.firestore.FieldValue.arrayUnion(
              ...newStateFocusesList
            )
          })
          .then(() => {
            console.log("added new state focuses list successfully");
          })
          .catch(err => {
            console.log("Error in adding new state focuses:", err);
          });
      }
    },
    addAnEmote(
      { commit, state },
      {
        //Move to tool
        emote
      }
    ) {
      //Change to the ability of adding an array of commitments
      const db = firebase.firestore(); //Move to single place
      let myFirebaseFirestoreTimestampFromDate = firebase.firestore.Timestamp.fromDate(
        new Date()
      );
      emote._created_at = myFirebaseFirestoreTimestampFromDate;

      let emoteDocRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("tools")
        .doc("emote");
      emoteDocRef
        .update({
          trackings: firebase.firestore.FieldValue.arrayUnion(emote)
        })
        .then(function() {
          console.log("Emote Logged");
        })
        .catch(function(error) {
          console.error("Error adding Emote log: ", error);
        });
    },
    logACheckIn(
      { commit, state },
      {
        //Move to tool
        checkin
      }
    ) {
      //Change to the ability of adding an array of commitments
      const db = firebase.firestore(); //Move to single place
      let myFirebaseFirestoreTimestampFromDate = firebase.firestore.Timestamp.fromDate(
        new Date()
      );
      checkin._created_at = myFirebaseFirestoreTimestampFromDate;

      let checkinDocRef = db
        .collection("users")
        .doc(state.user.uid)
        .collection("tools")
        .doc("checkin");
      checkinDocRef
        .update({
          logs: firebase.firestore.FieldValue.arrayUnion(checkin)
        })
        .then(function() {
          console.log("CheckIn Logged");
        })
        .catch(function(error) {
          console.error("Error adding  Check-In log: ", error);
        });
    },
    findingAUserByEmail({ commit, state }, { email }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        const userRef = db.collection("users").where("email", "==", email);
        userRef
          .get()
          .then(function(querySnapshot) {
            let isExist = false;
            querySnapshot.forEach(function(doc) {
              if (doc.exists) {
                isExist = true;
                res({ ...doc.data(), uid: doc.id });
                commit("SET_FIND_A_USER", {
                  findAUser: { ...doc.data(), uid: doc.id }
                });
              }
            });
            if (!isExist) {
              res(null);
              commit("SET_FIND_A_USER", { findAUser: null });
            }
          })
          .catch(err => [rej(err)]);
      });
    },
    actionResponseInvitationJourney({ commit, state, dispatch }, payload) {
      const { notif, response } = payload;
      const { user, names } = state;
      let listNamesUid = names.map(el => el.uid);
      const db = firebase.firestore(); //Move to single place

      const stateFocusesRef = db.doc("states/focuses");
      const focusRef = notif.focus;
      const notifRef = db.doc(`users/${user.uid}/lists/__notifications`);
      const joinsRef = db.doc(`users/${user.uid}/lists/__joins`);
      stateFocusesRef
        .get()
        .then(doc => {
          let stateFocusesList = [...doc.data().focuses];
          stateFocusesList = stateFocusesList.map((el, index) => {
            if (
              el.focus.path === notif.focus.path &&
              el.user &&
              el.user.id === user.uid
            ) {
              return {
                ...el,
                state: response,
                _updated_at: new Date()
              };
            }
            return el;
          });
          return stateFocusesRef
            .update({
              focuses: stateFocusesList
            })
            .then(() => {
              console.log("successfully updated state.focuses");
              // let nameToSave;

              return focusRef.get().then(doc => {
                let crews = [...doc.data().crew];
                let destination = doc.data().destination;

                // return dispatch('getListNamesOtherUser', {uid: notif.user_from.id})
                // .then((data) => {
                // console.log(data, "ini data hasil get names list orang lain yah")
                // let focusOwnerNames = data.items
                let newCrews = crews.map((el, index) => {
                  if (
                    el.connection &&
                    el.connection.user &&
                    el.connection.user.id === user.uid
                  ) {
                    let output = {
                      ...el,
                      join_status: response
                    };
                    if (response === "rejected") {
                      output._rejected_at = new Date();
                    } else if (response === "joined") {
                      // nameToSave = el.text;
                      output._joined_at = new Date();
                    }
                    return output;
                  } else {
                    return el;
                  }
                });
                return focusRef
                  .update({
                    crew: newCrews
                  })
                  .then(() => {
                    console.log("successfully updated user.focuses.crew");

                    return notifRef.get().then(doc => {
                      let notifs = [...doc.data().items];

                      notifs = notifs.map((el, index) => {
                        if (
                          el.type === "invitation" &&
                          el.focus.id === notif.focus.id &&
                          el.user_from.id
                        ) {
                          console.log("masuk kondisi if di update notif");
                          return {
                            ...el,
                            _answered_at: new Date(),
                            _answer: response
                          };
                        } else {
                          return el;
                        }
                      });
                      return notifRef
                        .update({
                          _updated_at: new Date(),
                          items: notifs
                        })
                        .then(() => {
                          console.log("successfully update __notifications");
                          if (response === "joined") {
                            return notif.user_from.get().then(userFromDoc => {
                              let {
                                imgURL,
                                firstname,
                                lastname
                              } = userFromDoc.data();
                              return joinsRef.get().then(doc => {
                                let newJoin = {
                                  _created_at: new Date(),
                                  _joined_at: new Date(),
                                  destination: destination.text1,
                                  focus: notif.focus,
                                  user: notif.user_from
                                };
                                if (imgURL) newJoin.imgURL = imgURL;
                                if (firstname) newJoin.firstname = firstname;
                                if (lastname) newJoin.lastname = lastname;
                                // if (nameToSave) newJoin.alias = nameToSave;

                                if (doc.exists) {
                                  return joinsRef
                                    .update({
                                      focuses: [...doc.data().focuses, newJoin]
                                    })
                                    .then(() =>
                                      console.log("successfully save in joinn")
                                    );
                                } else {
                                  return joinsRef
                                    .set({
                                      focuses: [newJoin]
                                    })
                                    .then(() =>
                                      console.log("successfully save in joinn")
                                    );
                                }
                              });
                            });
                          }
                        });
                    });
                  });
                // })
              });
            });
        })
        .catch(err => {
          console.log("there are errors in joining/rejecting invitation", err);
        });
    },
    addToDone({ commit, state }, { toDone }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore(); //Move to single place
        const toDoneRef = db.doc(`users/${state.user.uid}/lists/__todone`);

        return toDoneRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let toDones = [...doc.data().items];
              return toDoneRef
                .update({
                  items: [...toDones, { ...toDone }]
                })
                .then(() => {
                  console.log("successfully save toDone");
                  res(true);
                });
            } else {
              return toDoneRef
                .set({
                  _created_at: new Date(),
                  items: [{ ...toDone }]
                })
                .then(() => {
                  console.log("successfully save toDone");
                  res(true);
                });
            }
          })
          .catch(err => {
            console.log("error in save toDone: ", err);
            rej(err);
          });
      });
    },
    getToDone({ commit, state }) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        let toDoneRef = db.doc(`users/${state.user.uid}/lists/__todone`);
        toDoneRef.onSnapshot(snapshot => {
          if (snapshot.exists) {
            commit("SET_TO_DONE", { toDone: snapshot.data().items });
            res(snapshot.data().items);
          }
        });
      });
    },
    removeToDone({ commit, state }, { toDone }) {
      return new Promise((res, rej) => {
        let db = firebase.firestore();
        let toDoneRef = db.doc(`users/${state.user.uid}/lists/__todone`);
        return toDoneRef
          .get()
          .then(doc => {
            let toDones = [...doc.data().items];
            toDones = toDones.map(el => {
              if (el.text === toDone.text) {
                return {
                  ...el,
                  _deleted_at: new Date()
                };
              }
              return el;
            });
            return toDoneRef
              .update({
                items: toDones
              })
              .then(() => {
                console.log("successfully remove toDone");
                res(true);
              });
          })
          .catch(err => {
            console.log("error in removing toDone: ", err);
            rej(err);
          });
      });
    },
    setToolInEngineOnOrOff(
      { commit, state },
      { focusId, type, engine_id, toolUid }
    ) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const focusRef = db.doc(`users/${state.user.uid}/focuses/${focusId}`);
        return focusRef
          .get()
          .then(doc => {
            let engines = doc.data().engines;
            engines = engines.map(el => {
              if (el.engine_id === engine_id) {
                if (type === "on") {
                  el.focus_tool_ids.push({
                    _created_at: new Date(),
                    uid: toolUid
                  });
                } else {
                  el.focus_tool_ids = el.focus_tool_ids.filter(
                    e => e.uid !== toolUid
                  );
                }
              }
              return el;
            });
            return focusRef
              .update({
                engines: engines
              })
              .then(() => {
                console.log("successfully turn off/on a tool from an engine");
                res(true);
              });
          })
          .catch(err => {
            console.log("error while turn off/on a tool from an engine: ", err);
            rej(err);
          });
      });
    },
    getUserDeviceRegistrationToken({ commit, state }) {
      const messaging = firebase.messaging();
      const db = firebase.firestore();
      const userRef = db.collection("users").doc(state.user.uid);

      const saveTokenToDbToken = token => {
        const deviceItem = {
          token,
          _created_at: new Date()
        };

        userRef.get().then(doc => {
          if (!doc.data().device_registratons) {
            userRef
              .set(
                {
                  device_registratons: [deviceItem]
                },
                { merge: true }
              )
              .catch(function(err) {
                if (err) {
                  console.log(err.stack);
                }
              });
          } else {
            // debugger;
            const devices = doc.data().device_registratons;

            // find tokens in the db
            const index = Array.isArray(devices)
              ? devices.findIndex(val => val.token === token)
              : -1;

            // if already exists ignore updates
            if (index === -1) {
              // devices.push(deviceItems)
              userRef
                .update({
                  device_registratons: [deviceItem]
                })
                .catch(function(err) {
                  if (err) {
                    console.log(err.stack);
                  }
                });
            }
          }
        });
      };

      // Callback fired if Instance ID token is updated.
      messaging.onTokenRefresh(() => {
        messaging
          .getToken()
          .then(refreshedToken => {
            console.log("Token refreshed.");
            saveTokenToDbToken(refreshedToken);
          })
          .catch(err => {
            console.log("Unable to retrieve refreshed token ", err);
            commit("SET_DEVICE_REGISTRATION_TOKEN", false);
          });
      });

      // token request
      messaging
        .requestPermission()
        .then(function() {
          // get the token in the form of promise
          return messaging.getToken();
        })
        .then(function(token) {
          saveTokenToDbToken(token);
          commit("SET_DEVICE_REGISTRATION_TOKEN", token);
        })
        .catch(function(err) {
          if (err) {
            console.log(err.stack);
          }
          commit("SET_DEVICE_REGISTRATION_TOKEN", false);
        });

      messaging.onMessage(function(payload) {
        console.log("Message received. ", payload);
      });
    },
    getGuideSessions({ commit, state }, uid) {
      return new Promise((res, rej) => {
        let id = null;
        if (uid) {
          id = uid;
        } else {
          id = state.user.uid;
        }
        let db = firebase.firestore();
        const timesRef = db.doc(`users/${id}/lists/__guide_availability`);
        return timesRef
          .get()
          .then(doc => {
            if (doc.exists) {
              let times = [...doc.data().timings];
              res(times);
            } else {
              res();
            }
          })
          .catch(err => {
            console.log("Error in getting available times: ", err);
            rej(err);
          });
      });
    },
    saveGuideProfileName({ commit, state }, profileName) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guideRef = db.collection("users").doc(state.user.uid);

        return guideRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards.guide = {
            ...data._dashboards.guide,
            _updated_at: new Date(),
            username: profileName
          };
          return guideRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    makeGuideActive({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let guideRef = db.collection("users").doc(state.user.uid);

        return guideRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards.guide = {
            ...data._dashboards.guide,
            _created_at: new Date(),
            _account: {
              _created_at: new Date(),
              type: "free",
              status: "active"
            }
          };
          return guideRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    saveBloggerProfileName({ commit, state }, profileName) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let bloggerRef = db.collection("users").doc(state.user.uid);

        return bloggerRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards.blogger = {
            ...data._dashboards.blogger,
            _updated_at: new Date(),
            username: profileName
          };
          return bloggerRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    makeBloggerActive({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let bloggerRef = db.collection("users").doc(state.user.uid);

        return bloggerRef.get().then(doc => {
          let data = { ...doc.data() };
          data._dashboards.blogger = {
            ...data._dashboards.blogger,
            _created_at: new Date(),
            _account: {
              _created_at: new Date(),
              type: "free",
              status: "active"
            }
          };
          return bloggerRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    createArticle({ commit, state }, blog) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const blogsRef = db.doc(
          `users/${state.user.uid}/lists/__blogger_blogs`
        );
        blogsRef
          .get()
          .then(doc => {
            if (doc.exists) {
              blogsRef.update({
                blogs: [...doc.data().blogs, blog],
                _updated_at: new Date()
              });
            } else {
              blogsRef.set({
                _created_at: new Date(),
                blogs: [blog]
              });
            }
            res(true);
          })
          .catch(err => {
            console.log("error in saving list guide sessions1:", err);
          });
      });
    },
    getListBlogs({ commit, state }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let _guideSessionsRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("lists")
          .doc("__blogger_blogs");

        _guideSessionsRef
          .get()
          .then(function(doc) {
            if (doc.exists && doc.data().blogs && doc.data().blogs.length) {
              res(doc.data().blogs);
            } else {
              res(true);
            }
          })
          .catch(function(error) {
            console.error("Error in getting blogs: ", error);
            rej(error);
          });
      });
    },
    updateBlog({ commit, state }, blog) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const bloggerRef = db.doc(
          `users/${state.user.uid}/lists/__blogger_blogs`
        );
        return bloggerRef.get().then(doc => {
          let data = { ...doc.data() };
          data.blogs.forEach(aBlog => {
            if (aBlog.id == blog.id) {
              aBlog.title = blog.title;
              aBlog.synopsis = blog.synopsis;
              aBlog.spheres = blog.spheres;
              aBlog.seo = blog.seo;
              aBlog._updated_at = new Date();
            }
          });
          return bloggerRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    deleteBlog({ commit, state }, blog) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let blogs = [];
        const blogsRef = db.doc(
          `users/${state.user.uid}/lists/__blogger_blogs`
        );
        blogsRef.get().then(snapShot => {
          blogs = snapShot.data().blogs;
          blogs.forEach(aBlog => {
            if (aBlog.id == blog.id) {
              blogsRef
                .update({
                  blogs: firebase.firestore.FieldValue.arrayRemove(aBlog)
                })
                .then(() => {
                  res(true);
                })
                .catch(e => {
                  rej(e);
                  console.log("Error while updating blog:", e);
                });
            }
          });
        });
      });
    },
    submitBlog({ commit, state }, blog) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        const bloggerRef = db.doc(
          `users/${state.user.uid}/lists/__blogger_blogs`
        );
        return bloggerRef.get().then(doc => {
          let data = { ...doc.data() };
          data.blogs.forEach(aBlog => {
            if (aBlog.id == blog.id) {
              aBlog.status = "submitted";
              aBlog._submitted_at = new Date();
            }
          });
          return bloggerRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateFocus({ commit, state }, { focusId, destination }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let focusRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("focuses")
          .doc(focusId);
        return focusRef.get().then(doc => {
          let data = { ...doc.data() };
          data.destination = {
            detail: destination.detail,
            text1: destination.text1,
            text2: destination.text2
          };
          return focusRef
            .update({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateFocusEngines({ commit, state }, { engines, focus }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let focusRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("focuses")
          .doc(focus.focusId);

        return focusRef.get().then(doc => {
          let data = { ...doc.data() };
          data.engines = engines;
          data._updated_at = new Date();
          return focusRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateFocusCrew({ commit, state }, { crew, focus }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let focusRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("focuses")
          .doc(focus.focusId);

        return focusRef.get().then(doc => {
          let data = { ...doc.data() };
          data.crew = crew;
          data._updated_at = new Date();
          return focusRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    updateFocusState({ commit, state }, { focusState, focus }) {
      return new Promise((res, rej) => {
        const db = firebase.firestore();
        let focusRef = db
          .collection("users")
          .doc(state.user.uid)
          .collection("focuses")
          .doc(focus.focusId);
        let focuses = state.focuses;
        let index = 0;
        focuses.forEach(focus => {
          if (focus.state == focusState) {
            index++;
          }
        });
        return focusRef.get().then(doc => {
          let data = { ...doc.data() };
          data.state = focusState;
          data.position = index;
          data._updated_at = new Date();
          return focusRef
            .set({
              ...data
            })
            .then(function() {
              console.log("Document successfully updated!");
              res(true);
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
              rej(error);
            });
        });
      });
    },
    showNotification({ commit, state }, { title, description, variant }) {
      let bootStrapToaster = new BToast();
      bootStrapToaster.$bvToast.toast(description, {
        title: title,
        variant: variant,
        solid: true
      });
    }
  },
  //synchronous
  mutations: {
    UPDATED_FOCUS_POSITION(state, items) {
      state.focusesPosition.push(items);
    },
    UPDATE_USER(state, { user }) {
      state.user = user;
    },
    SET_PROFILE(state, profile) {
      if (profile) {
        state.profile = profile;
      } else {
        state.profile = {};
      }
    },
    SET_NAMES_NUMBERS_PLACES(state, namesNumbersPlaces) {
      if (namesNumbersPlaces) {
        state.namesNumbersPlaces = namesNumbersPlaces;
      } else {
        state.namesNumbersPlaces = {};
      }
    },
    SET_NAMES(state, names) {
      if (names.length) {
        state.names = names;
      } else {
        state.names = [];
      }
    },
    SET_TOOLS(state, tools) {
      if (tools.length) {
        state.tools = tools;
      } else {
        state.tools = [];
      }
    },
    SET_JOURNEYS(state, journeys) {
      if (journeys.length) {
        state.journeys = journeys;
      } else {
        state.journeys = [];
      }
    },
    SET_EVENTS(state, events) {
      if (events.length) {
        state.events = events;
      }
    },
    SET_USER_SESSIONS(state, sessions) {
      if (sessions.length) {
        state.sessions = sessions;
      }
    },
    SET_GUIDE_SESSIONS(state, sessions) {
      if (sessions.length) {
        state.guideSessions = sessions;
      }
    },
    SET_NOTIFICATIONS(state, notifications) {
      if (notifications.length) {
        state.notifications = notifications;
      } else {
        state.notifications = [];
      }
    },
    SET_FOCUSES(state, focuses) {
      if (focuses) {
        state.focuses = focuses;
      } else {
        state.focuses = [];
      }
    },
    SET_TAGS(state, { status }) {
      state.status = status;
    },
    SET_LISTS(state, { lists }) {
      state.lists = lists;
    },
    SET_LIST_ENGINE(state, list) {
      if (list.length) {
        state.listEngine = list;
      } else {
        state.listEngine = [];
      }
    },
    SET_STATUS(state, { status }) {
      state.status = status;
    },
    SET_ERROR(state, { error }) {
      state.error = error;
    },
    SET_ROLES(state, { roles }) {
      state.roles = roles;
    },
    SET_FIND_A_USER(state, { user }) {
      state.findAUser = user;
    },
    SET_JOINS(state, joins) {
      if (joins) {
        state.joins = joins;
      } else {
        state.joins = {};
      }
    },
    SET_LIST_TOOLS_CONNECTED_USERS(state, listTool) {
      if (listTool) {
        state.listConnectedUsersTools.push(listTool);
      }
    },
    SET_TO_DONE(state, { toDone }) {
      if (toDone) {
        state.toDone = toDone;
      }
    },
    SET_SCHEDULES(state, { schedules }) {
      if (schedules) {
        state.schedules = schedules;
      }
    },
    SET_SCHEDULE_EVENTS(state, { scheduleEvents }) {
      if (scheduleEvents) {
        state.scheduleEvents = scheduleEvents;
      }
    },
    SET_LIST_NAMES_CONNECTED_USERS(state, listNames) {
      if (listNames) {
        state.listConnectedUsersNames.push(listNames);
      }
    },
    SET_JOIN_TOOLS(state, tools) {
      if (tools) {
        state.joinTools[tools.uid] = tools.tools;
      }
    },
    SET_DEVICE_REGISTRATION_TOKEN(state, token) {
      if (!token) {
        state.notificationPermission = false;
      } else {
        state.userDevice.push(token);
        state.notificationPermission = true;
      }
    }
  }
};

function setLocalStorageUserData(response) {
  const { user } = response;
  const { uid, displayName, photoURL, email, phoneNumber } = user;
  localStorage.setItem("userData", JSON.stringify(response.user));
  localStorage.setItem("uid", uid);
  localStorage.setItem("firstName", displayName.split(" ")[0]);
  localStorage.setItem(
    "lastName",
    displayName
      .split(" ")
      .slice(1)
      .join(" ")
  );
  localStorage.setItem("photoURL", photoURL);
  localStorage.setItem("email", email);
  localStorage.setItem("phoneNumber", phoneNumber);
}

function removeLocalStorageUserData() {
  localStorage.removeItem("userData");
  localStorage.removeItem("uid");
  localStorage.removeItem("firstName");
  localStorage.removeItem("lastName");
  localStorage.removeItem("photoURL");
  localStorage.removeItem("email");
  localStorage.removeItem("phoneNumber");
}
